<template>
  <div id="dialog-shop-cart" v-if="$route.name !== 'shop-checkout'">
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-badge color="red" overlap right>
          <template v-slot:badge>
            <span v-if="states.length">{{ states.length }}</span>
          </template>
          <v-btn color="primary" fab icon>
            <v-icon @click="addItem()" color="white" v-on="on" x-large>shopping_cart</v-icon>
          </v-btn>
        </v-badge>
      </template>
      <v-card>
        <v-card-title>
          <h1 class="title head-page">รายการสินค้า</h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xs v-if="states.length">
            <v-layout align-center justify-center :key="state.idx" row v-for="state in states" wrap>
              <v-flex pt-2 xs12>
                {{
                getProductItemName(state.shopEditionProductItemId) + ' ' + state.name
                }}
              </v-flex>
              <v-flex xs4>{{ state.price + ' บาท' }}</v-flex>
              <v-flex xs4>
                <v-text-field
                  data-vv-name="quantity"
                  :error-messages="errors.collect('quantity')"
                  label="จำนวน"
                  single-line
                  type="number"
                  v-model="state.quantity"
                  v-validate="'numeric'"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-btn @click.stop="deleteCart(state.idx)" color="red" dark depressed small>ลบ</v-btn>
              </v-flex>
              <v-flex xs12></v-flex>
              <v-flex xs12>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container grid-list-xs v-else>
            <v-layout align-center justify-center row wrap>
              <v-flex text-xs-center xs12>
                <div class="caption">ไม่พบรายการสินค้า</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn> -->
          <v-btn @click.prevent="doSubmit()" color="green" dark :loading="dialogLoading">สั่งซื้อ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'dialog-shop-cart',
  data() {
    return {
      quantity: [],
      dialogLoading: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.Cart.idx) {
        this.formData = this.$store.getters['Cart/getAll'].filter(
          item => item.idx == this.$store.state.Cart.idx
        )[0]
      } else {
        this.formData = []
        if (this.$store.state.ConsultingTopic.idx) {
          this.formData.consultingTopicId = this.$store.state.ConsultingTopic.idx
        }
      }
    }
  },
  computed: {
    states() {
      return this.$store.getters['Cart/getAll']
    },
    dialogItem: {
      // getter
      get() {
        return this.$store.state.Cart.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('Cart/UPDATE_DIALOG', newValue)
      }
    }
  },
  async created() {},
  methods: {
    deleteCart(idx) {
      this.$store.dispatch('Cart/delete', idx)
    },
    getProductItemName(shopEditionProductId) {
      return this.$store.getters['ShopEditionProductItem/getAll']
        .filter(item => item.idx == shopEditionProductId)
        .map(item => item.name)
        .toString()
    },
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          this.$store.dispatch(`Cart/update`, this.states)
          this.$router.push({ name: 'shop-checkout' })
          // this.formData.idx
          // : await this.$store.dispatch(`Cart/insert`, data)
          this.$store.commit(`Cart/UPDATE_DIALOG`, false)
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    addItem() {
      this.$store.commit('Cart/UPDATE_DIALOG', true)
    }
  }
}
</script>

<style lang="scss" scoped>
#dialog-shop-cart {
  position: fixed;
  bottom: 5px;
  right: 15px;
  z-index: 4;
}
</style>
